<template>
  <div id='expandImage' class="expanded-image out hidden" @click="expandImage">
    <img
      class="shadow-lg w-100 border-radius-lg product-image picture-cursor"  style="height: 100%"
      :class="!image ? 'noimageColorEdit': ''"
      :src="!image ? noimage: image"
      alt="Cargando..." />
  </div>
</template>

<script>

import noimage from  "@/assets/img/sevica-images/noimage.png";

export default {
  name: "ImageExpanded",
  props: {
    imagePath: {
      type: String,
      default: "",
    },
    display: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      image: null,
      noimage,
    }
  },
  watch: {
    imagePath() {
      this.image = this.imagePath
    }
  },
  methods: {
    expandImage() {
      let expanded = document.getElementById('expandImage')

      if (expanded.classList.contains('out') || expanded.classList.contains('hidden')) {
        expanded.classList.remove('hidden');
        expanded.classList.remove('out');
        expanded.classList.add('active');
      } else {
        expanded.classList.remove('active');
        expanded.classList.add('out');    
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.picture-cursor {
  cursor: url('../../../assets/img/zoom-out.svg'), auto;
}

.noimageColorEdit{ 
  opacity: 0.1 !important;
}

.back-button {
  color: #4A7062
}

.product-image {
  object-fit: contain;
  transition: transform .2s;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
}

.product-image-click {
  transform: scale(1.9);
  z-index: 1040;
  background-color: #000;
}

.hidden {
  display: none !important;
}

.expanded-image {
  position: absolute;
  height: 50%;
  width: 34%;
  top: 50px;
  left: -60px;
  border-radius: 6px;
  background-color: white;
  -webkit-transition: all .3s ease-in-out;
  transition        : all .3s ease-in-out;
  display: block;

  &.active {
    animation: scale-display .3s;
    display: block;
  }

	&.out {
		animation: scale-display--reversed .3s;
		animation-fill-mode:forwards;
    display: block;
	}
}

@keyframes scale-display {
	0% {
		opacity: 0;
		transform: scale(0);
    -webkit-transform: scale(0);
	}

	100% {
		opacity: 1;
		transform: scale(1);
    -webkit-transform: scale(1);
	}
}

@keyframes scale-display--reversed {
	0% {
		display: inline-flex;
		opacity: 1;
		transform: scale(1);
		-webkit-transform: scale(1);
	}
	99% {
		display: inline-flex;
		opacity: 0;
		transform: scale(0);
		-webkit-transform: scale(0);
	}
	100% {
		display: none;
		opacity: 0;
		transform: scale(0);
		-webkit-transform: scale(0);
	}
}
</style>